import { render, staticRenderFns } from "./Page-with-mixed-menu.vue?vue&type=template&id=18829c93&"
import script from "./Page-with-mixed-menu.vue?vue&type=script&lang=js&"
export * from "./Page-with-mixed-menu.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports